import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { ChangeableEmailProps } from '~/components/SendEmailBlock/components/MessageHeader';
import { WithAccountContext } from '~/contexts/AccountContext';
import RowLabel from './RowLabel';
import { withAccountContext } from '~/contexts/AccountContext';
import TEST_ID from './SenderRow.testid';
import Link from '~/components/Link';
import useEmailConfigLink from '~/hooks/useEmailConfigLink';
import { isNil } from 'ramda';
import { NamedEmail } from '~/util/namedEmailFormatter';
import InputComponent from './InputComponent';

const text = {
  senderLabel: 'Van:',
  notSyncedCorrectly: (link: string) => (
    <>
      Er is een probleem met dit e-mail adres. De eigenaar van de e-mail adres
      kan het{' '}
      <Link dataTestid={TEST_ID.EMAIL_SOURCE_LINK} to={link}>
        hier
      </Link>{' '}
      repareren
    </>
  ),
};
type MyProps = {
  isEmailSynced: boolean | null;
  changeableEmail: ChangeableEmailProps;
  disabled?: boolean;
  shouldValidate: boolean;
};
type Props = WithAccountContext & MyProps;

const SenderRow: React.FC<Props> = ({
  changeableEmail,
  disabled,
  shouldValidate,
  isEmailSynced = null,
}): React.ReactElement => {
  const [senderOption, setSender] = useState<NamedEmail | null>(null);
  useEffect(() => {
    if (changeableEmail.readOnly && changeableEmail.namedEmail) {
      const { namedEmail } = changeableEmail;

      setSender(namedEmail);
    } else {
      const { selectedIdx, options } = changeableEmail;
      const senderOption =
        !isNil(selectedIdx) && selectedIdx >= 0
          ? options[selectedIdx].payload
          : null;
      setSender(senderOption);
    }
  }, [changeableEmail]);

  const emailConfigLink = useEmailConfigLink({ senderOption });

  return (
    <>
      <SenderLabel>{text.senderLabel}</SenderLabel>

      <SenderInput>
        <InputComponent
          changeableEmail={changeableEmail}
          disabled={disabled}
          shouldValidate={shouldValidate}
          dataTestId={TEST_ID.DROPDOWN}
        />
      </SenderInput>
      {isEmailSynced === false && (
        <ErrorLabel data-testid={TEST_ID.EMAIL_ERROR_LABEL}>
          {text.notSyncedCorrectly(emailConfigLink)}
        </ErrorLabel>
      )}
    </>
  );
};

const SenderLabel = styled(RowLabel)<{}>`
  grid-row: sender-start / sender-end;
  grid-column: label-start / label-end;
`;

const ErrorLabel = styled.div(
  ({ theme }) => css`
    grid-column: input-start / button-end;
    color: ${theme.color('danger')};

    a {
      color: ${theme.color('danger')};
    }
  `,
);

const SenderInput = styled.div<{}>`
  grid-row: sender-start / sender-end;
  grid-column: input-start / button-end;
`;

export default withAccountContext<MyProps>(SenderRow);
